import eCharts from 'vue-echarts'
import BusinessTable from '../components/BusinessTable'
import BusinessDatePicker from '../components/BusinessDatePicker'
import RangeDatePicker from '../components/RangeDatePicker'
import ElRangeDatePicker from '../components/el-range-datepicker'
import BusinessUploader from '../components/businessUploader/Index'
import WebpImage from '../components/Image/WebpImage.vue'

import BusinessSteps from '../components/BusinessSteps/Index.vue'
import BusinessCard from '../components/BusinessCard'
import NoDataSegment from './NoDataSegment'
import ElUploadImg from '../components/el-upload-img'
import ElPage from '../components/el-page'
import ElDialogConfirm from '../components/el-dialog-confirm'

export const installComponents = app => {
  app.component('BusinessTable', BusinessTable)
  app.component('BusinessDatePicker', BusinessDatePicker)
  app.component('RangeDatePicker', RangeDatePicker)
  app.component('ElRangeDatePicker', ElRangeDatePicker)
  app.component('eCharts', eCharts)
  app.component('BusinessUploader', BusinessUploader)
  app.component('BusinessSteps', BusinessSteps)
  app.component('BusinessCard', BusinessCard)
  app.component('NoDataSegment', NoDataSegment)
  app.component('ElUploadImg', ElUploadImg)
  app.component('ElPage', ElPage)
  app.component('ElDialogConfirm', ElDialogConfirm)
  app.component('WebpImage', WebpImage)
}
